import { render, staticRenderFns } from "./WaitPayment.vue?vue&type=template&id=286fb5a3&scoped=true&"
import script from "./WaitPayment.vue?vue&type=script&lang=js&"
export * from "./WaitPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fb5a3",
  null
  
)

export default component.exports